import useData from './data-service'
import type { Person } from '../types/persons'

/**
 * Returns the Person section of the page's data.
 */
export default function usePerson(): Person | undefined {
  return useData()?.person
}
